var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "custom-control custom-radio custom-control-inline" },
    [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.internalPicked,
            expression: "internalPicked"
          }
        ],
        staticClass: "custom-control-input",
        attrs: {
          type: "radio",
          name: _vm.name,
          id: _vm.key,
          required: _vm.required
        },
        domProps: {
          value: JSON.stringify(_vm.value),
          checked: _vm._q(_vm.internalPicked, JSON.stringify(_vm.value))
        },
        on: {
          change: [
            function($event) {
              _vm.internalPicked = JSON.stringify(_vm.value)
            },
            _vm.onChange
          ]
        }
      }),
      _vm._v(" "),
      _c(
        "label",
        { staticClass: "custom-control-label", attrs: { for: _vm.key } },
        [_vm._v("\n        " + _vm._s(_vm.label) + "\n    ")]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-26e8ef88", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26e8ef88","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./_wwwsrc/js/ConventionServitude/Components/RadioInput.vue
// module id = 644
// module chunks = 0